export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_INITIAL':
      return action.payload;

    case 'SET_SOCIO':
      return { ...state, infoSocio: action.payload };

    case 'SET_NEXT_STEP':
      return { ...state, activeStep: state.activeStep + 1 };

    case 'SET_PREVIOUS_STEP':
      return { ...state, activeStep: state.activeStep - 1 };

    default:
      throw new Error(`Unknown action: ${JSON.stringify(action)}`);
  }
};
